import React from "react";
import DataTable from "react-data-table-component";
import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";
import LoadingIcon from "../images/animated_loading.gif";
import merge from "lodash.merge";
import { cn } from "../lib/utils";
import { ArrowIcon } from "../svg";

const Loader = () => {
	return (
		<div className="flex-col p-2 mb-4 tab-content-ins flex-cont flex-centered">
			<p>Fetching data, please wait...</p>
			<img src={LoadingIcon} className="loading-img" alt="Loading..." />
		</div>
	);
};

const CustomDataTable = ({
	children,
	containerClassName,
	emptyStateMessage = "There are no records to display",
	alterParams = true,
	customStyles,
	...props
}) => {
	const [searchParams] = useSearchParams();

	const perPage = parseInt(searchParams.get("limit") || "15");

	const defaultStyles = {
		table: {
			style: {
				paddingTop: "1rem",
				marginBottom: "2rem",
				backgroundColor: "transparent",
				overflow: "auto",
				"&>div": { backgroundColor: "transparent" },
			},
		},
		headRow: {
			style: {
				fontSize: "16px",
				fontWeight: 600,
				color: "rgba(51, 51, 51, 1)",
				backgroundColor: "transparent",
				paddingInline: "20px",
			},
		},
		headCells: {
			style: {
				// paddingInline: 0,
			},
		},
		rows: {
			style: {
				backgroundColor: "transparent",
				borderBottom: "1px solid #EAEBF0",
				paddingBlock: "0.75rem",
				paddingInline: "20px",
			},
		},
		cells: {
			style: {
				// paddingInline: 0,
				fontSize: "15px",
				color: "#000000",
				fontWeight: 500,
			},
		},
	};

	const mergedStyles = merge({}, defaultStyles, customStyles);

	return (
		<div
			className={cn(
				"tw-flex tw-w-full tw-flex-col tw-overflow-x-scroll tw-bg-white tw-shadow-[0_0_5px_rgba(0,0,0,0.2)] tw-rounded-[10px]",
				containerClassName
			)}
		>
			<DataTable
				progressComponent={<Loader />}
				pagination
				paginationServer
				paginationPerPage={perPage}
				paginationComponent={Pagination}
				noDataComponent={<div className="max-w-[240px] tw-p-[24px] font-semibold text-[#2C323C]">{emptyStateMessage}</div>}
				customStyles={mergedStyles}
				{...props}
			/>
			{children}
		</div>
	);
};

const Pagination = ({ rowCount, onChangePage, onChangeRowsPerPage }) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const updateSearchParams = (key, value) => {
		const newSearchParams = new URLSearchParams(searchParams);

		newSearchParams.set(key, value);

		setSearchParams(newSearchParams);
	};

	const rowsPerPage = parseInt(searchParams.get("limit") || "0") || 15;

	const pageCount = Math.ceil(rowCount / rowsPerPage);

	const handlePageClick = ({ selected }) => {
		updateSearchParams("page", selected + 1);
		onChangePage(selected + 1, rowCount);
	};

	return (
		<div className="tw-pb-6 tw-flex tw-flex-wrap-reverse tw-gap-5 tw-px-6">
			<ReactPaginate
				breakLabel="..."
				previousLabel={<ArrowIcon className="tw-h-[15px] tw-w-[15px] tw-mr-3" />}
				nextLabel={<ArrowIcon className="tw-h-[15px] tw-rotate-180 tw-w-[15px] rotate-180 tw-ml-3" />}
				onPageChange={handlePageClick}
				pageRangeDisplayed={3}
				marginPagesDisplayed={2}
				pageCount={pageCount}
				renderOnZeroPageCount={null}
				forcePage={searchParams.has("page") ? parseInt(searchParams.get("page") || "1") - 1 : 0}
				containerClassName="tw-flex tw-items-center tw-gap-4 tw-ml-auto"
				activeClassName="!tw-text-black"
				pageClassName="tw-text-[18px] tw-font-semibold tw-text-[#33333371]"
				previousClassName="custom-pagination-previous"
				nextClassName="custom-pagination-next"
			/>
		</div>
	);
};

export default CustomDataTable;
